import React, { useState } from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { getBorderRadius } from 'Components/utils';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import classnames from 'classnames';

const useStyles = buildUseStyles('Image', ((theme) => ({
  root: {
    display: ({ loading }) => (loading ? 'none' : 'inherit'),
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
  borderRadius: {
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  loading: {
    height: 'auto',
  },
})));

const Image = ({ value, noBorderRadius }) => {
  const [loading, setLoading] = useState(true);
  const classes = useStyles({ loading });

  return (<>
    {loading && <LoadingIndicator className={classes.loading} />}
    <img
      alt={'announcement'}
      className={classnames(classes.root, {
        [classes.borderRadius]: !noBorderRadius,
      })}
      src={value}
      onLoad={() => { setLoading(false); }}
    />
  </>);
};


Image.defaultProps = {
  noBorderRadius: false,
};

Image.propTypes = {
  value: PropTypes.string.isRequired,
  noBorderRadius: PropTypes.bool,
};

export default Image;
